import React, { Component } from "react";

import { NavLink } from "react-router-dom";

import {
  Header,
  HeaderContent,
  HeaderToggler,
  Collapse,
  Nav,
  NavItem,
  Icon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  LinkList,
} from "design-react-kit";

import { ROUTES } from "../../const";

export class NHSegreteriaIUL extends Component {
  state = {
    collapsed: true,
  };

  manageEvtByLink = (link) => {
    this.setState({ collapsed: true });
  };

  //--- ---

  render() {
    const isOpen = !this.state.collapsed;

    return (
      <>
        <Header small theme="" type="navbar">
          <HeaderContent expand="lg" megamenu>
            <HeaderToggler
              aria-controls="nav1"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => this.setState({ collapsed: isOpen })}
            >
              <Icon icon="it-burger" />
            </HeaderToggler>
            <Collapse
              isOpen={isOpen}
              navbar
              header
              onOverlayClick={() => this.setState({ collapsed: true })}
            >
              <div className="menu-wrapper mnemo-dark">
                <Nav navbar tag="ul" vertical={false}>
                  <NavItem
                    key={`menu-item-close`}
                    tag="li"
                    onClick={() => this.setState({ collapsed: isOpen })}
                  >
                    <div className="mnemo-close-li">
                      CHIUDI <Icon icon="it-close-circle" padding={false} />
                    </div>
                  </NavItem>

                  <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                    <NavLink
                      className="nav-link"
                      to={ROUTES.DASHBOARD_SEGRETERIA_IUL}
                    >
                      Dashboard
                    </NavLink>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          aria-haspopup
                          caret
                          color="secondary"
                          nav
                        >
                          Calendario Lezioni
                        </DropdownToggle>

                        <DropdownMenu
                          flip
                          ag="div"
                          className="dropdown-menu-show-fix mnemo-dark"
                        >
                          <LinkList tag="div">
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.IUL_COURSE_LIST_ONLINE}
                                ag="a"
                              >
                                Calendario Lezioni online
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.IUL_COURSE_LIST_ONSITE}
                                ag="a"
                              >
                                Calendario Lezioni in presenza
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.IUL_COURSE_LIST_TRAINING}
                                ag="a"
                              >
                                Calendario Tirocinio Indiretto
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.IUL_COURSE_LIST_STUDENT}
                                ag="a"
                              >
                                Lezioni per studente
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li" onClick={this.props.logout}>
                    <NavLink className="nav-link" to="/" ag="a">
                      Esci
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Collapse>
          </HeaderContent>
        </Header>
      </>
    );
  }
}
